import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token-Website'

const UserKey = 'Admin-User-Website'

const EnterpriseKey = 'Admin-Enterprise'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getUser() {
  return JSON.parse(localStorage.getItem(UserKey))
}

export function setUser(user) {
  return localStorage.setItem(UserKey, JSON.stringify(user))
}

export function removeUser() {
  return localStorage.removeItem(UserKey)
}

export function getEnterprise() {
  return JSON.parse(localStorage.getItem(EnterpriseKey))
}

export function setEnterprise(enterprise) {
  return localStorage.setItem(EnterpriseKey, JSON.stringify(enterprise))
}

export function removeEnterprise() {
  return localStorage.removeItem(EnterpriseKey)
}